/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const deleteApiAlbumsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор альбома.")
    })

/**
 * @description Альбом удален
 */
export const deleteApiAlbumsId200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const deleteApiAlbumsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const deleteApiAlbumsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const deleteApiAlbumsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Альбом не найден
 */
export const deleteApiAlbumsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const deleteApiAlbumsId500Schema = z.lazy(() => badResponseModelSchema)

export const deleteApiAlbumsIdMutationResponseSchema = z.lazy(() => deleteApiAlbumsId200Schema)